import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/billing-codes',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/BillingCodesContainer',
      './modules/billingCodes'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const BillingCodes = require('./containers/BillingCodesContainer').default
      const actions = require('./modules/billingCodes')
      const reducer = require('./modules/billingCodes').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'billingCodes', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, BillingCodes)

    /* Webpack named bundle   */
    }, 'billingCodes')
  }
})



// WEBPACK FOOTER //
// ./src/routes/BillingCodes/index.js